import { render } from "./FollowUpAssessment.vue?vue&type=template&id=7b90d4aa&scoped=true"
import script from "./FollowUpAssessment.vue?vue&type=script&lang=js"
export * from "./FollowUpAssessment.vue?vue&type=script&lang=js"

import "./FollowUpAssessment.vue?vue&type=style&index=0&id=7b90d4aa&scoped=true&lang=css"

import exportComponent from "/var/www/html/nchsaet-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b90d4aa"]])

export default __exports__